import { render } from "./aboutConstruction.vue?vue&type=template&id=46d9e6aa"
import script from "./aboutConstruction.vue?vue&type=script&lang=js"
export * from "./aboutConstruction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__